export default __webpack_public_path__ + "static/media/torbjorn-intro.988f9307.mp3";